var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPvp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#FDBB53"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.8257 22.5C56.7504 22.5 57.5 23.2496 57.5 24.1742V31.8401C57.5 32.8204 57.0704 33.7514 56.3245 34.3876L29.6549 57.1333C29.2645 57.4663 28.7412 57.6014 28.2624 57.417C27.4651 57.1102 26.158 56.4562 24.8509 55.1493C23.5438 53.8423 22.8898 52.5353 22.5829 51.7381C22.3987 51.2593 22.5338 50.7361 22.8667 50.3458L45.6143 23.6756C46.2506 22.9297 47.1817 22.5 48.1621 22.5H55.8257Z",
    fill: "#F1564C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5358 42.61L57.1333 50.3458C57.4662 50.7361 57.6013 51.2593 57.4171 51.7381C57.1102 52.5353 56.4562 53.8423 55.1491 55.1493C53.842 56.4562 52.5349 57.1102 51.7376 57.417C51.2588 57.6014 50.7355 57.4663 50.3451 57.1333L41.9258 49.9525L50.5358 42.61ZM31.8379 22.5C32.8183 22.5 33.7494 22.9297 34.3857 23.6756L38.3567 28.3317L29.1842 39.0867L23.6755 34.3876C22.9794 33.7939 22.5587 32.9433 22.5057 32.0355L22.5 31.8401V24.1742C22.5 23.2496 23.2496 22.5 24.1743 22.5H31.8379Z",
    fill: "#FDBB53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3863 47.1255L57.1333 50.3459C57.4662 50.7362 57.6013 51.2595 57.417 51.7382C57.1101 52.5354 56.4561 53.8424 55.149 55.1494C53.8419 56.4563 52.5348 57.1104 51.7376 57.4172C51.2588 57.6015 50.7354 57.4664 50.345 57.1335L46.9468 54.236C48.8564 52.4222 51.3363 50.052 54.3863 47.1255Z",
    fill: "#FC8B46"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8294 54.6742L54.407 42.6852C54.7267 42.3542 55.2543 42.345 55.5853 42.6647L56.7842 43.8224C57.7774 44.7816 57.8051 46.3642 56.8459 47.3574L47.5838 56.9486C46.6247 57.9418 45.042 57.9695 44.0488 57.0103L42.8499 55.8526C42.5189 55.5329 42.5097 55.0053 42.8294 54.6742Z",
    fill: "#FDBB53"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6533 47.0767L32.9233 54.3458L29.6549 57.1333C29.2645 57.4662 28.7412 57.6014 28.2624 57.417C27.4651 57.1102 26.158 56.4562 24.8509 55.1493C23.5438 53.8423 22.8898 52.5353 22.5829 51.7381C22.3987 51.2593 22.5338 50.7361 22.8667 50.3457L25.6533 47.0767Z",
    fill: "#BB3333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0003 40L29.167 50.8333",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2428 54.5409L25.4577 42.7558C25.1322 42.4303 24.6046 42.4303 24.2792 42.7558L23.1006 43.9343C22.1243 44.9106 22.1243 46.4935 23.1006 47.4698L32.5287 56.8979C33.505 57.8742 35.088 57.8742 36.0643 56.8979L37.2428 55.7194C37.5682 55.3939 37.5682 54.8663 37.2428 54.5409Z",
    fill: "#F1564C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPvp);
export default __webpack_public_path__ + "static/media/pvp.b17729a9afdd4b70b63c53efa24869ff.svg";
export { ForwardRef as ReactComponent };